module.exports = __webpack_public_path__ + "static/media/app02_ch01.5c002be4.png";